// extracted by mini-css-extract-plugin
export default {"expiredContent":"expiredContent__expiredContent___HLWlG"};